"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubDejaSouscritTypeCorporation = void 0;
exports.ESubDejaSouscritTypeCorporation = {
    logement: "logement",
    murs_commerce: "murs_commerce",
    autre: "autre",
};
